export default "__VITE_ASSET__atYvDljq__"